<div class="locations-result">
  <div *ngFor="let loc of locations()" class="location-card">
    <div class="location-header">
      <div class="location-meta">
        <span class="location-name">{{ loc.name }}</span>
        <span *ngIf="loc.address || loc.city" class="location-address">
          {{ loc.address
          }}{{ loc.city ? (loc.address ? ', ' : '') + loc.city : ''
          }}{{ loc.state ? ', ' + loc.state : '' }}
        </span>
      </div>
      <span class="location-stats">
        {{ loc.edgeCount }} edge{{ loc.edgeCount !== 1 ? 's' : '' }} ·
        {{ loc.cameraCount }} cam{{ loc.cameraCount !== 1 ? 's' : '' }}
      </span>
    </div>

    <!-- Camera list (shown when cameras are available) -->
    <div class="camera-list" *ngIf="loc.cameras?.length">
      <div class="camera-item" *ngFor="let cam of loc.cameras">
        <svg
          class="camera-icon"
          viewBox="0 0 16 16"
          fill="none"
          width="12"
          height="12"
        >
          <path
            d="M1 4.5A1.5 1.5 0 0 1 2.5 3h8A1.5 1.5 0 0 1 12 4.5v.382l2.707-1.353A.5.5 0 0 1 15 4v8a.5.5 0 0 1-.293.447L12 11.118V11.5A1.5 1.5 0 0 1 10.5 13h-8A1.5 1.5 0 0 1 1 11.5v-7z"
            fill="currentColor"
            opacity="0.7"
          />
        </svg>
        <span class="camera-name">{{ cam.cameraName || cam.cameraId }}</span>
      </div>
    </div>
  </div>
  <div *ngIf="locations().length === 0" class="empty-state">
    No locations found.
  </div>
</div>
